// extracted by mini-css-extract-plugin
export default {"componentWrapper":"GridSwitcher_componentWrapper__k4QTM","gridIcon":"GridSwitcher_gridIcon__IkEbk","active":"GridSwitcher_active__VfNj+","name":"GridSwitcher_name__sbznA"};